export default __webpack_public_path__ + "static/media/13.64df4e36.jpg";